<template>
    <div v-if="loaded && ready" class="home">
      <hero-home :lang="lang" :homeData="homeData" :incPagePos="incPagePos" :isMobile="isMobile"></hero-home>
      <home-proj :lang="lang" :projects="homeData.projects" :isMobile="isMobile"></home-proj>

      <div class="destak" :class="destakVisited" v-if="lang == 0">

        <div class="destak-cont">
          <div class="destak-title">
            Quando tudo <br class="m">é novidade <br class="m"> é quando<br class="d"> mais precisamos de criatividade
          </div>

          <div class="destak-row">
            <div class="destak-col">
              <strong>Agência do Ano</strong>
              <br>
              <span>Experiência de Marca</span>
            </div>

            <div class="destak-col">
              <img src="/static/images/ccp.png" alt="ccp">

            </div>
          </div>
         </div>


      </div>
      <div class="destak" :class="destakVisited" v-if="lang == 1">

        <div class="destak-cont">
          <div class="destak-title">
            When all <br class="m">it's new <br class="m">is when<br class="d"> we need more creativity
          </div>

          <div class="destak-row">
            <div class="destak-col">
              <strong>Agency of the Year</strong>
              <br>
              <span>Brand Experience</span>
            </div>

            <div class="destak-col">
              <img src="/static/images/ccp.png" alt="ccp">

            </div>
          </div>
         </div>


      </div>

      <div class="content-footer-home" :class="footerVisited">

        <footer-nossa :lang="lang" :isMobile="isMobile"></footer-nossa>


      </div>

      <!--blog-post :idPost="homeData.html[lang].post" :idScreen="'free-html'"></blog-post>
      <blog-post :idPost="homeData.blog[lang].post" :idScreen="'blog-post'"></blog-post-->










    </div>
</template>

<script>



    import {NavEvents} from "../dataModules/NavEvents";
    import {TweenMax} from "gsap/TweenMax";
    import {EVENTBUS, WP, getExtension, testInsert} from '../main';
    import HeroHome from "./Modules/HeroHome";
    import HomeProj from "./Modules/HomeProj";
    import LatNav from "./Modules/LatNav";

    import FooterNossa from "./FooterNossa";
    import FooterNossaMob from "./bk/FooterNossaMob";

    export default {

        name: 'home',
      components: {FooterNossaMob, FooterNossa, LatNav, HomeProj, HeroHome},
      props: ['isMobile', 'lang'],
        data() {
            return {
                homeData: [],
                loaded: false,
                ready: false,
                incPagePos: 0,
                stopInc: false,
                totalScreens: 3,
                totalProj: 3,
                actualScreen: 0,
                actualProj: 0,

              destakVisited : '',
              footerVisited : '',
              main: {},
              stopSwipe: false,




              navEvt : {},


              hd: {
                  title: 'NOSSA™',
                  desc: 'A description of the page',
                  img: 'https://nossavisao.pt/nossanew/wp/wp-content/uploads/2022/01/FCT_SWEAT_2.jpg',
              }


            }


        },

      head: {
        title: function () {
          const _this = this;
          return {
            inner: 'NOSSA™',   separator: ' ',   complement: ''
          }
        },
/*

        meta: function () {
          const _this = this;
          return [
            { name: 'application-name', content: 'NOSSA Website' },
            { name: 'description', content: _this.hd.title, id: 'desc' },

            { name: 'twitter:title', content: _this.hd.title },
            { n: 'twitter:description', c: _this.hd.desc},

            { itemprop: 'name', content: _this.hd.title },
            { itemprop: 'description', content: _this.hd.desc},

            { p: 'og:url', c: window.location.href },
            { p: 'og:type', c: 'website' },
            { p: 'og:og:site_name', c: _this.hd.title },
            { p: 'og:title', c: _this.hd.title },
            { p: 'og:description', c: _this.hd.desc },
            { p: 'og:image', itemprop: "image", c: _this.hd.img },
            { p: 'og:image:width', c: '256'},
            { p: 'og:image:height', c: '256'},
          ]
        }
*/


      },

        created() {

          const _this = this;

          WP('home', function (response){

            _this.homeData = response[0];
            _this.loaded = true;

/*
            if(_this.homeData.html) {
              _this.totalScreens ++;
            }

            if(_this.homeData.blog) {
              _this.totalScreens ++;
            }

*/

            _this.init();


          });
          //testInsert();

        },
        mounted() {

            EVENTBUS.$on('wheelSwitchHome', this.wheelSwitch);
            //EVENTBUS.$on('AAA', AAA);
            //EVENTBUS.$emit('AAA', 0);
          //$('main').on("wheel", this.wheelEVTFF);



          if(!this.isMobile){
            $(window).scrollTop(0);
            $('body, html').scrollTop(0);
          }else{
            $(window).scrollTop(1000);
            $('body, html').scrollTop(100)
          }


          this.ready = true;

          this.init();


          setInterval(function(){

            var boda = (typeof window.outerHeight != 'undefined')?Math.max(window.outerHeight, $(window).height()):$(window).height();



            //  EVENTBUS.$emit('log', $(window).height() + ' ' + $('.home').css('transform'))


          //   EVENTBUS.$emit('log', st )

           // $('main').height(window.innerHeight);


          }, 20000000000);






        },

        destroyed() {
          this.navEvt.wheelSwitch(false);
        },

        methods: {

            init() {

              const _this = this;

              if(this.loaded && this.ready){




                EVENTBUS.$emit('changeLatNav', 1);

                this.main =document.getElementById('main');
              //  this.wheelSwitch(true);


                this.navEvt = new NavEvents(document.getElementById('main'), this.incPageEVTByPass, true);
                this.navEvt.wheelSwitch(true);
                this.resizeMe();




              }



            },

          resizeMe(){

              if(this.isMobile){
                $('.home .hero').height(window.innerHeight);
                $('.destak').height(window.innerHeight);
                $('#main-home-proj').height(window.innerHeight);
                $('.home-proj-item').height(window.innerHeight);
                $('.content-footer-home').height(window.innerHeight);
                $('.lat-nav').height(window.innerHeight - 50);
              }


          },






          /********************************************************************************
           ********************************************************************************
           ********************************************************************************
           ********************************************************************************
           ********************************************************************************/

          /*
          incPageEVT(n){
            if(!this.stopInc){
                if(this.incPagePos >= 0 && n === 0){
                  this.incPagePos --;
                }else {
                  this.incPagePos ++;
                }
                console.log(this.incPagePos)
              }
          },

           */


          incPageEVTByPass(n){
           // console.log('this.actualProj : ' +  this.actualProj)
            if(!this.stopInc){



              this.resizeMe();



              if(this.actualScreen == 1) {


                if(n === 0) {
                  if(this.actualProj > 0){
                    this.actualProj --;
                    EVENTBUS.$emit('incHomeProj',  this.actualProj);
                  }else{
                    this.incPageEVT(n);
                  }
                }

                if(n === 1){
                  if(this.actualProj < this.totalProj ){
                    this.actualProj ++;
                    EVENTBUS.$emit('incHomeProj',  this.actualProj);
                  }else{
                    this.incPageEVT(n);
                  }
                }




              }else{
                this.incPageEVT(n);
              }


           //   this.wheelSwitch(false);

              //this.stopInc = true;
            }



          },

          incPageEVT(n){

              if(this.actualScreen > 0 && n === 0){
                this.actualScreen --;
              }

              if(this.actualScreen < this.totalScreens && n === 1){
                this.actualScreen ++;
              }

              this.movePage();


           // this.stopInc = true;


          },



          movePageByPass(){

            /*

            totalScreens: 3,
                totalProj: 3,
                actualScreen: 0,
                actualProj: 0,

            EVENTBUS.$emit('incHomeProj', 0);
             */


          },

          movePage(){

            const _this = this;

          //  console.log(_this.actualScreen + ' move ' + _this.totalScreens)

            let ref = 0

            if(_this.actualScreen < _this.totalScreens){
              ref = 0 - (_this.actualScreen * window.innerHeight);
            }else{
              ref = 0 - ((_this.actualScreen - 1) * window.innerHeight);

              if(!_this.isMobile){
                ref -=420;
              }else{
                ref = 0 - (_this.actualScreen * window.innerHeight);
              }

            }








         //  this.wheelSwitch(false);
           this.controlPages(_this.actualScreen);



            TweenMax.to( '.home', 1, {y: ref , force3D: true, ease:  Power2.easeOut, onComplete: function(){




              }} );





          },
          
          
          controlPages(n){
            const _this = this;

            EVENTBUS.$emit('changeLatNav', (n+1));

            if(n == 1) {

              EVENTBUS.$emit('control-proj-home', true);
            }else{
              EVENTBUS.$emit('control-proj-home', false);
            }

            if(n == 2) {

              setTimeout(function(){
                _this.destakVisited = 'visited';
              }, 300);


            }
            if(n == 3) {

              setTimeout(function(){
                EVENTBUS.$emit('showFooter');
                _this.footerVisited = 'visited';
              }, 300);


            }
          }







        },
    };

</script>


// WEBPACK FOOTER //
// src/components/Home.vue